var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fee903",
    d: "M326.438 7.26C302.198 33.539 267.471 50 228.9 50c-27.534 0-53.109-8.388-74.309-22.748C75.832 67.993 22 150.21 22 245c0 135.31 109.69 245 245 245s245-109.69 245-245c0-114.812-78.974-211.178-185.562-237.74z",
    opacity: 1,
    "data-original": "#fee903",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.596,
    cy: 212.957,
    r: 200,
    fill: "#fed402",
    opacity: 1,
    "data-original": "#fed402",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2fbff",
    d: "M185.856 14.144v376.555c0 7.811 6.332 14.144 14.144 14.144h221.331a8.93 8.93 0 0 0 8.93-8.93V106.751a8.935 8.935 0 0 0-.802-3.699c-.439-.964-12.464-3.324-13.228-4.088l-82.372-84.355c-.764-.764-4.733-13.368-5.697-13.807A8.942 8.942 0 0 0 324.463 0H200c-7.811 0-14.144 6.332-14.144 14.144z",
    opacity: 1,
    "data-original": "#f2fbff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5eef9",
    d: "M193 395.912V8.93A8.93 8.93 0 0 1 201.93 0h-75.298a8.93 8.93 0 0 0-8.93 8.93v386.982a8.93 8.93 0 0 0 8.93 8.93h75.298a8.93 8.93 0 0 1-8.93-8.93z",
    opacity: 1,
    "data-original": "#e5eef9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8e8f0",
    d: "M336.162 103.052h93.296a8.933 8.933 0 0 0-1.813-2.616l-96.868-97.82a8.92 8.92 0 0 0-2.616-1.813v94.249a8.001 8.001 0 0 0 8.001 8z",
    opacity: 1,
    "data-original": "#d8e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec6ed",
    d: "M314.726 180h-63.55c-5.523 0-10-4.477-10-10s4.477-10 10-10h63.55c5.523 0 10 4.477 10 10s-4.477 10-10 10zM295.446 220h-44.269c-5.523 0-10-4.477-10-10s4.477-10 10-10h44.269c5.523 0 10 4.477 10 10s-4.478 10-10 10z",
    opacity: 1,
    "data-original": "#bec6ed"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d5daf3",
    d: "M366.142 260H251.176c-5.523 0-10-4.477-10-10s4.477-10 10-10h114.965c5.523 0 10 4.477 10 10 .001 5.523-4.477 10-9.999 10zM366.142 340H251.176c-5.523 0-10-4.477-10-10s4.477-10 10-10h114.965c5.523 0 10 4.477 10 10 .001 5.523-4.477 10-9.999 10zM385.422 300H251.176c-5.523 0-10-4.477-10-10s4.477-10 10-10h134.246c5.523 0 10 4.477 10 10s-4.477 10-10 10z",
    opacity: 1,
    "data-original": "#d5daf3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8783d1",
    d: "M272 376.001c0 25.979-7.285 50.257-19.923 70.903a22.381 22.381 0 0 1-7.395 7.395c-20.645 12.638-44.923 19.923-70.903 19.923-74.861.001-136.002-61.14-136.001-136.001 0-25.969 7.279-50.238 19.908-70.878a22.486 22.486 0 0 1 7.436-7.436C85.761 247.279 110.03 240 135.999 240c74.861-.001 136.002 61.14 136.001 136.001z",
    opacity: 1,
    "data-original": "#4f66d0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d58ba",
    d: "M253.351 444.779C229.727 484.999 186.017 512 136 512c-43.407 0-82.065-20.336-106.965-52-2.531-3.219 6.141-5.854 3.904-9.297C19.1 429.405 11.061 403.992 11.061 376.7c0-20.512 4.541-39.963 12.673-57.403 1.363-2.924-8.234-6.491-6.674-9.297a136.666 136.666 0 0 1 50.16-51.351c-11.852 20.179-18.649 43.685-18.649 68.779 0 75.111 60.889 136 136 136 25.094.001 48.601-6.796 68.78-18.649z",
    opacity: 1,
    "data-original": "#314dc9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a4",
    d: "M292.34 400c0-11.046-8.954-20-20-20 11.046 0 20-8.954 20-20s-8.954-20-20-20c11.288 0 20.391-9.351 19.987-20.729-.385-10.838-9.621-19.271-20.466-19.271h-81.316c-3.627 0-6.047-3.741-4.561-7.049l17.303-38.504c5.203-11.578 1.893-24.818-7.26-32.697-2.012-1.732-5.16-2.079-7.709-3.218-6.029-2.695-10.825.36-13.532 6.383l-18.468 46.511c-2.008 4.468-5.265 8.29-9.451 10.835-7.699 4.681-19.319 14.443-27.144 23.695-4.74 5.605-11.661 8.902-19.002 8.902H71.18v118.69c0 8.534 6.918 15.452 15.452 15.452h33.124c10.174 0 20.2 2.109 29.662 5.848 8.3 3.28 17.344 5.082 26.81 5.082h96.112c11.046 0 20-8.954 20-20 0-10.649-8.323-19.354-18.819-19.965 10.496-.611 18.819-9.316 18.819-19.965z",
    opacity: 1,
    "data-original": "#fed2a4",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffbd86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.077 328.963 25.85-1.791c7.341 0 14.262-3.297 19.002-8.902 7.825-9.252 15.992-16.52 23.692-21.201 4.186-2.545 7.443-6.367 9.451-10.835 0 0 30.078-63.519 28.957-64.484a28.001 28.001 0 0 0-6.854-4.343c-6.029-2.695-13.106.027-15.812 6.05l-20.495 45.605c-2.008 4.469-5.265 8.29-9.451 10.835-7.699 4.681-15.867 11.948-23.692 21.201-4.74 5.605-11.661 8.902-19.002 8.902H71.18zM272.34 400.815h-63.091a9.593 9.593 0 0 0 0 19.186h63.091c11.046 0 20-8.954 20-20 0-3.476-.887-6.745-2.447-9.593-3.396 6.201-9.983 10.407-17.553 10.407zM272.341 360.815H209.25a9.593 9.593 0 0 0 0 19.186h63.091c11.046 0 20-8.954 20-20 0-3.476-.887-6.745-2.447-9.593-3.397 6.201-9.984 10.407-17.553 10.407zM289.851 310.45c-3.396 6.202-9.984 10.407-17.553 10.407h-63.091a9.593 9.593 0 0 0 0 19.186h63.091c11.046 0 20-8.954 20-20 0-3.477-.887-6.745-2.447-9.593zM289.689 429.973c-3.452 6.001-9.928 10.042-17.349 10.042h-62.726c-5.499 0-9.957 4.458-9.957 9.957 0 5.499 4.458 9.957 9.957 9.957h62.726c11.046 0 20-8.954 20-20 0-3.624-.964-7.023-2.651-9.956z",
    fill: "#ffbd86",
    opacity: 1,
    "data-original": "#ffbd86",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#01c0fa",
    d: "M0 376c0 31.703 10.848 60.873 29.035 84H74c8.837 0 16-7.163 16-16V326c0-8.837-7.163-16-16-16H17.061C6.191 329.545 0 352.05 0 376z",
    opacity: 1,
    "data-original": "#01c0fa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#62dbfb",
    d: "M90.228 470h-18c-8.837 0-16-7.163-16-16V316c0-8.837 7.163-16 16-16h18c8.837 0 16 7.163 16 16v138c0 8.837-7.163 16-16 16z",
    opacity: 1,
    "data-original": "#62dbfb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5dd39e",
    d: "M155.511 155.17h-20v-20c0-5.523-4.477-10-10-10s-10 4.477-10 10v20h-20c-5.523 0-10 4.477-10 10s4.477 10 10 10h20v20c0 5.523 4.477 10 10 10s10-4.477 10-10v-20h20c5.523 0 10-4.477 10-10s-4.478-10-10-10z",
    opacity: 1,
    "data-original": "#fe7701",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fea713",
    d: "M92.389 88.698h-20v-20c0-5.523-4.477-10-10-10s-10 4.477-10 10v20h-20c-5.523 0-10 4.477-10 10s4.477 10 10 10h20v20c0 5.523 4.477 10 10 10s10-4.477 10-10v-20h20c5.523 0 10-4.477 10-10s-4.477-10-10-10z",
    opacity: 1,
    "data-original": "#fea713",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.73ae86e3864c13430582c0a67dbf8149.svg";
export { ForwardRef as ReactComponent };